<script setup lang="ts">
</script>

<template>
  <router-view />
</template>
<!-- 全局样式 -->

<style>
.popover-content
{
  z-index: 99;
}
</style>
